import axios from 'axios'
import { LISTAR_FILTROS_ITINERARIO_EMBARQUE } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listaFiltrosItinerarioEmbarque (idEmpresa) {
  const url = `${URL}/itinerario/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_ITINERARIO_EMBARQUE,
        payload: response

      })
  );
}
